import React, { useState } from "react";
import { Modal, Button, Form, Switch, Card } from 'antd';
import notification from '../../../services/notification';
import { X, Trash, } from "@phosphor-icons/react";
import { FormattedMessage, useIntl } from "react-intl";
import { UserDelete } from '../../../services/users';

const DeleteUserModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    userProfileData,
    history,
    refreshData,
}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const intl = useIntl();

    const onSubmit = () => {
        setButtonDisabled(true);
        setConfirmDelete(false);

        if (userProfileData) {
            // invoice exist, also delete from server
            UserDelete(userProfileData, history)
                .then(response => {
                    if (response.status) {
                        notification['success']({
                            message: 'User',
                            description: intl.formatMessage({ id: response.msg }),
                        });
                    } else {
                        notification['error']({
                            message: 'User',
                            description: intl.formatMessage({ id: response.msg }),
                        });
                    }
                    modalIsOpenHandler(false);
                    refreshData();
                })
                .catch(error => {
                    setButtonDisabled(false);

                    notification['error']({
                        message: 'Account',
                        description: intl.formatMessage({ id: "UNKNOW_ERROR" }),
                    });
                });

        } else {
            modalIsOpenHandler(false);
            history('/dashboard');
            notification['warning']({
                message: 'User',
                description: "User not found",
            });
        }

    };

    return (

        <Modal
            open={modalIsOpen}
            title={<><Trash size={16} weight="light" /> <FormattedMessage id="delete-user" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            className="danger"
            footer={[
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<X size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    danger={true}
                    type="primary"
                    loading={buttonDisabled}
                    disabled={!confirmDelete}
                    onClick={onSubmit}
                    icon={!buttonDisabled && (<Trash size={16} weight="light" />)}>
                    <FormattedMessage id="delete-user" />
                </Button>,
            ]}>

            <Card
                className="my-4"
                title={<><h3><FormattedMessage id="delete-user-info" /> {userProfileData.user_data.user_first_name} {userProfileData.user_data.user_last_name}?</h3></>}>
                <Form
                // labelCol={{ span: 20 }}
                // wrapperCol={{ span: 4 }}
                >

                    <Form.Item label={<FormattedMessage id="user-delete-confirm" />}>
                        <Switch
                            className="danger"
                            checked={confirmDelete}
                            onChange={e => setConfirmDelete(!confirmDelete)}
                        />
                    </Form.Item>

                </Form>
            </Card>
        </Modal>
    );
};


export default DeleteUserModal;
